import { render, staticRenderFns } from "./AssistTeacherEdit.vue?vue&type=template&id=9d11853e&scoped=true&"
import script from "./AssistTeacherEdit.vue?vue&type=script&lang=js&"
export * from "./AssistTeacherEdit.vue?vue&type=script&lang=js&"
import style0 from "./AssistTeacherEdit.vue?vue&type=style&index=0&id=9d11853e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d11853e",
  null
  
)

export default component.exports